<template>
  <main
    class="min-h-screen w-full overflow-hidden bg-grey"
    :dir="locale == 'ar' ? 'rtl' : 'ltr'"
    :class="locale == 'ar' ? 'font-[Cairo]' : 'font-poppins'"
  >
    <div class="min-h-screen w-full grid grid-cols-1 lg:grid-cols-5">
      <div
        class="relative col-span-1 lg:col-span-3 flex items-center justify-center px-4 py-10 lg:px-12"
      >
        <div
          class="pointer-events-none absolute inset-0 opacity-70"
          style="
            background: radial-gradient(
                circle at 12% 18%,
                rgba(215, 0, 103, 0.08),
                transparent 42%
              ),
              radial-gradient(
                circle at 88% 82%,
                rgba(1, 0, 102, 0.1),
                transparent 45%
              );
          "
        ></div>
        <div
          class="relative w-full max-w-[560px] animate-[authFadeIn_0.55s_var(--transition-smooth)_both]"
        >
          <slot></slot>
        </div>
      </div>

      <aside
        class="relative hidden lg:flex col-span-2 min-h-screen overflow-hidden bg-[url(@/assets/images/auth_cover.png)] bg-cover bg-center"
      >
        <div
          class="absolute inset-0 bg-gradient-to-t from-primary via-primary/70 to-primary/20"
        ></div>
        <div
          class="absolute inset-0 opacity-40"
          style="
            background: linear-gradient(
              135deg,
              transparent 40%,
              rgba(215, 0, 103, 0.25) 100%
            );
          "
        ></div>

        <div
          class="relative z-10 mt-auto mb-16 w-full px-10 flex flex-col items-center text-center animate-[authFadeUp_0.7s_var(--transition-smooth)_0.15s_both]"
        >
          <img
            class="w-28 drop-shadow-lg transition-transform duration-500 hover:scale-105"
            src="@/assets/logo.png"
            :alt="$t('logo')"
          />
          <p class="mt-6 text-white/90 text-lg font-semibold tracking-wide">
            {{ $t("tassis_school_system") }}
          </p>
          <p class="mt-2 text-white/65 text-sm max-w-xs leading-relaxed">
            {{ $t("welcome_to_tasis_system_school") }}
          </p>
        </div>
      </aside>
    </div>
  </main>
</template>

<script setup>
import { Repo } from "@/store/admin/repo";
import { useI18n } from "vue-i18n";
import { onMounted } from "vue";

const { locale } = useI18n();

onMounted(() => {
  Repo.yearBreadCrumb = [];
});
</script>

<style scoped>
@keyframes authFadeIn {
  from {
    opacity: 0;
    transform: translateY(12px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes authFadeUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
